export default __webpack_public_path__ + "static/media/applied_filter.6745e7a6.svg";